import { register, CloudObject, Tag, Transaction, defineProperty, defineRelation, Direction } from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class State extends CloudObject {

    /**
     * Creates an instance of State.
     *
     * @param {!Transaction} transaction
     * @return {!string} the tag of the created instance
     */
    static create(transaction) {
        return transaction.create(State);
    }
    
    /**
     * @return {string}
     */
    getName() {
        return this.get(State.nameProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeName($) {
        return this.observe($, State.nameProp);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setName(transaction, instance, value) {
        transaction.update(instance, State.nameProp, value);
    }

}

// Hardcoded tags
register('018b8af72fad621feb3f', State);
State.nameProp = defineProperty('018b8af7467dfb84735f');
State.inverse_requestcurrentStateRel = defineRelation('018b8af76ecd2972aa0b', Direction.ORIGIN);
